import styled from "styled-components";

export const Background = styled.div`
  background-color: #EFEFEF;
  width: 100%;
`;
export const P = styled.p`
font-family: 'Open Sans', sans-serif;
font-size: 13px;
margin-top: 1.3%;

`;
export const Body = styled.p`
font-family: 'Open Sans', sans-serif;
font-size: 13px;
margin-top: 1.3%;
display: flex;
width: 100%;
`;
export const Rodape = styled.div`
display: flex;
 position: absolute;
 bottom: 20px;
 right: 20px;
 width: 220px;
`;
export const Logo = styled.img`
width: 40px;
`;
export const Container = styled.div`
width: 100%;
height: 100%;
`;


export const Center= styled.div`
margin: 1.5% 1%;
display: flex;
flex-direction: column;
align-items: center;
border-radius: 17px;
padding: 5%;
width: 50%;
margin-left: 20px;
`
